export default [
  {
    id: 1,
    title: '品牌介绍',
    type: 'brand',
    qa: [
      {
        question: '什么是网心云？',
        id: 'brand-1',
        answer:
          '网心云是由深圳市网心科技有限公司打造的闲置带宽、存储和算力的共享边缘计算C端采集平台，与B端星域云产品打通闭环生态，为企业提供创新型分布式云计算服务。',
      },
      {
        question: '网心云是怎么赚钱的？',
        id: 'brand-2',
        answer:
          '通过迅雷网心科技的自研技术，将闲置的网络带宽、存储等计算资源转化成有价值的共享云计算服务，在为网心科技星域云提供资源服务的同时，用户可获得现金收益。',
      },
      {
        question: '如何加入网心云？',
        id: 'brand-3',
        answer:
          '1.  加入计划<br  />通过网心云官网/APP，选择硬件或激活码招募方式；<br  />  2.添加设备<br  />扫描设备二维码或输入激活码添加设备；<br  />3.保持在线<br  />保持设备在线，APP查看每日收益；',
      },
      //   {
      //     question: '登录账号如何注销？',
      //     answer: '网心账号暂无法注销',
      //   },
      //   {
      //     question: '网心云有云添加功能吗？',
      //     answer: '网心云的主要功能是将闲置网络流量资源变现，网心云APP没有玩客奖励计划及云添加功能。',
      //   },
    ],
  },
  {
    id: 2,
    title: '新手教程',
    type: 'tutorials',
    qa: [
      {
        question: '现金版盒子硬件',
        id: 'tutorials-1',
        answer: '/help/tutorials/wxy-cash-box',
      },
      // {
      //   question: '网心盒子硬件',
      //   id: 'tutorials-2',
      //   answer: '/help/tutorials/wxbox',
      // },
      {
        question: '小爱盒子激活码',
        id: 'tutorials-3',
        answer: '/help/tutorials/xiaoaibox',
      },
      {
        question: '玩客云现金版激活码',
        id: 'tutorials-4',
        answer: '/help/tutorials/onecloud-cash',
      },
      {
        question: '三方盒子激活码',
        id: 'tutorials-5',
        answer: '/help/tutorials/sf',
      },
      {
        question: 'x86激活码',
        id: 'tutorials-6',
        answer: '/help/tutorials/x86',
      },
      //   {
      //     question: '如何关联网心云？',
      //     answer:
      //       '1.绑定设备<br  />扫描设备背面二维码下载玩客云APP，并绑定成功；<br  />2.关联设备<br  />下载网心云APP，输入玩客云账号和密码进行关联；  ',
      //   },
      //   {
      //     question: '关联设备时提示“您关联的账号下绑定的非网心设备”是什么意思？',
      //     answer: '该设备非网心云，建议您通过官方渠道进行购买。',
      //   },
      //   {
      //     question: '如何批量关联设备？',
      //     answer: '通过APP首页点击【进入分组】—【添加设备】—【账号批量关联】，根据提示操作。',
      //   },
      //   {
      //     question: '一个账号最多关联多少台网心云？',
      //     answer: '目前最多可以关联1000台',
      //   },
      //   {
      //     question: '如何解除关联设备？',
      //     answer: '苹果通过左滑设备信息，安卓通过长按设备信息',
      //   },
      //   {
      //     question: '在玩客云APP解绑网心云，玩客云账号跟网心账号还是关联的吗？',
      //     answer: '是关联的，需要到网心云移除关联的玩客云账号。',
      //   },
      //   {
      //     question: '账号关联与激活码关联有什么区别？',
      //     answer:
      //       '账号关联主要针对网心设备关联，使用用户自己注册的玩客云账号与密码进行关联；激活码关联主要针对FX设备关联，使用激活用的激活码进行关联，与玩客云APP无关系。',
      //   },
      //   {
      //     question: '激活码关联的设备可以使用玩客云APP吗？',
      //     answer: '不可使用，FX设备是刷机转为网心设备的，不支持使用玩客云APP。',
      //   },
    ],
  },
  {
    id: 3,
    title: '刷机教程',
    type: 'install',
    qa: [
      {
        question: '三方盒子(FX)安装教程',
        id: 'install-1',
        // answer: 'https://box.onethingpcs.com/help-center/install/sf/',
        answer: 'https://help.yfanqie.com/7cb4/3ed5/77f6',
      },
      {
        question: '三方盒子(WJY)安装教程',
        id: 'install-2',
        // answer: 'https://box.onethingpcs.com/help-center/install/wjy/',
        answer: 'https://help.yfanqie.com/7cb4/3ed5/67eb',
      },
      {
        question: 'x86(Hyper-V)安装教程',
        id: 'install-3',
        // answer: 'https://box.onethingpcs.com/help-center/install/x86/',
        answer: 'https://w.1yb.co/V987xaE',
      },
      {
        question: 'x86(KVM)安装教程',
        id: 'install-4',
        // answer: 'https://box.onethingpcs.com/help-center/install/kvm/',
        answer: 'https://help.yfanqie.com/1f8d/35e9/279e',
      },
      {
        question: 'x86(ISO)安装教程',
        id: 'install-5',
        // answer: 'https://box.onethingpcs.com/help-center/install/iso/',
        answer: 'https://w.1yb.co/VOvylqE',
      },
      {
        question: 'x86(VMware)安装教程',
        id: 'install-6',
        // answer: 'https://box.onethingpcs.com/help-center/install/vmware/',
        answer: 'https://w.1yb.co/E1jxDXV',
      },
      {
        question: 'x86(群晖)安装教程',
        id: 'install-7',
        // answer: 'https://box.onethingpcs.com/help-center/install/qunhui/',
        answer: 'https://help.yfanqie.com/1f8d/35e9/9af0',
      },
    ],
  },
  {
    id: 4,
    type: 'account',
    title: '账号与登录',
    qa: [
      {
        question: 'APP支持自动登录吗？',
        id: 'account-1',
        answer: 'APP支持15天内自动登录，如无法自动登录请检查下网络环境',
      },
      {
        question: '手机无法接收验证码',
        id: 'account-2',
        answer:
          '1、核实手机是否安装了拦截软件  ；<br  />2、把手机卡拿出来更换到其他手机操作；<br  />3、更换时间段操作；<br  />4、咨询运营商是否屏蔽了SP商短信下发接收端口；<br  />5、如以上都未能解决，请记录“操作时间、手机、异常现象”，反馈客服处理。',
      },
      {
        question: '可以支持多台手机同时登录吗？',
        id: 'account-3',
        answer: '暂不支持多台手机同时登录',
      },
      //   {
      //     question: '同一网络环境下，相同的设备和硬盘，为何收益不同？',
      //     answer:
      //       '同一网络环境下，导致收益不同的因素有以下原因：<br  />1、在同一带宽下，网络出口之间会存在带宽资源互抢的情况；<br  />2、系统缓存数据和访问数据的随机性，还有调度策略的不均衡都会影响收益不同。',
      //   },
      //   {
      //     question: '为什么前期会出现0收益或低收益的情况',
      //     answer:
      //       '新上线设备或换新盘设备，在前期会有2-5天的缓存部署期，待缓存部署完毕后，贡献的上行流量会逐渐提高，收益也会逐渐提高至平稳阶段。',
      //   },
      //   {
      //     question: '收益与哪些因素有关？',
      //     answer:
      //       '您好，收益与实际贡献的上行流量正相关，上行最低流量与上行带宽（运营商网络容易有波动，特别是晚高峰）、磁盘容量和性能（同型号性能有差异）、upnp是否打开、NAT类型、缓存大小（与下行网络、磁盘容量质量相关）等相关，请您自行检查，如仍遇到异常问题，可联系客服解决。',
      //   },
      //   {
      //     question: '收益将如何更新？',
      //     answer: '每天早上9点更新前一天0点到24点的收益，所有数据均以9点后为准。',
      //   },
      //   {
      //     question: '如何查看已发放和未发放收益',
      //     answer: '手机登录网心云，在【我的】—【我的钱包】—查看累计收益、已提现收益和账户余额。',
      //   },
      //   {
      //     question: '在玩客云APP解绑网心云还会产生收益吗？',
      //     answer: '不会产生收益，因为网心账号关联的玩客云账号名下已无绑定的网心云。',
      //   },
    ],
  },
  {
    id: 5,
    title: '激活添加',
    type: 'activate',
    qa: [
      {
        question: '如何激活设备？',
        id: 'activate-1',
        answer:
          '目前提供了2种激活方式：<br/>1、打开本地页面进行激活；<br/>2、通过扫描二维码，然后输入激活码进行激活。',
      },
      {
        question: '如何添加设备？',
        id: 'activate-2',
        answer:
          '目前提供了3种添加方式：<br/>1、扫描设备对应二维码进行添加；<br/>2、输入设备对应激活码进行添加；<br/>3、输入玩客云账号密码进行添加。',
      },
      {
        question: '一个账号最多可添加多少台设备？',
        id: 'activate-3',
        answer: '目前最多可以添加1000台，如果超过可注册新的账号进行管理',
      },
      {
        question: '如何移除设备？',
        id: 'activate-4',
        answer: '苹果通过左滑设备信息移除设备，安卓通过长按设备信息移除设备',
      },
      //   {
      //     question: '如何区分所有的设备类型？',
      //     answer:
      //       '答：除了正常售卖的网心设备没有标记，其他设备都会在设备列表打上标记。网心体验——标记为体验，网心租赁——标记为租赁，FX设备——标记为FX，FX体验——标记为体验；',
      //   },
      //   {
      //     question: '如果设备转给其他人关联，标记会跟着设备变化吗？',
      //     answer: '会的，标记是针对设备进行的，如果设备发生变更，则标记也跟着变更。',
      //   },
      //   {
      //     question: '体验和租赁的设备收益什么时候开始计算？',
      //     answer:
      //       '满足设备SN码转为网心设备，且保持网心账号-玩客云账号-网心SN码三者绑定关系，则开始计算收益。',
      //   },
      //   {
      //     question: '体验和租赁到期后如何显示',
      //     answer: '体验和租赁到期后设备显示异常，标记一直显示，当发生解除关联后标记不再显示。',
      //   },
      //   {
      //     question: '如何修改设备备注',
      //     answer: '手机登录网心云，点击【设备】—【进入分组】—点击对应设备备注修改。',
      //   },
      //   {
      //     question: '体验时间是怎么计算的？',
      //     answer:
      //       '体验开始时间+93天（截止到前一天24:00）。例如，开始时间是2019年4月24日19:00，则结束时间是2019年7月25日24:00。',
      //   },
      //   {
      //     question: '租赁时间是怎么计算的？',
      //     answer: '网心多预留10天时间给到用户，租赁期的为付款后的375天。',
      //   },
      //   {
      //     question: '网心云有云添加功能吗？',
      //     answer:
      //       '网心云的主要功能是将闲置网络流量资源变现，网心云APP没有玩客奖励计划及云添加功能，通过玩客云APP可以实现个人文件的上传和下载。',
      //   },
    ],
  },
  {
    id: 6,
    title: '设备管理',
    type: 'device',
    qa: [
      {
        question: '如何区分产品类型对应的标记？',
        id: 'device-1',
        answer:
          '目前总共有6类设备：<br/>1、网心盒子：WxBox<br/>2、玩客云现金版：WkyC<br/>3、小爱盒子：XA<br/>4、x86：x86<br/>5、网心云开放版：WxOpen<br/>6、三方盒子：SF',
      },
      {
        question: '如何将设备从一个分组移动至另一个分组？',
        id: 'device-2',
        answer:
          '单台设备移动，IOS可以通过左滑设备，安卓可通过长按设备；<br/>多台设备移动可以通过分组页右上角批量移组进行；',
      },
      {
        question: '设备排序是分别按照什么规则进行的？',
        id: 'device-3',
        answer:
          '1.默认排序：按照添加设备时间倒序排列；<br/>2.备注排序：按照设备备注名称，以字典顺序进行排序；<br/>3.昨日收益最高：按照昨日收益由高到低排序；<br/>4.最日收益最低：按照昨日收益由低到高排序；<br/>5.总收益最高：按照总收益由高到低排序；<br/>6.总收益最低：按照总收益由低到高排序。',
      },
      {
        question: 'x86的硬件设备是哪些？',
        id: 'device-4',
        answer: 'x86硬件设备包含：服务器，PC电脑，星际蜗牛，NAS设备及其它x86架构设备。',
      },
      {
        question: '设备状态如何分类？分别什么意思？',
        id: 'device-5',
        answer:
          '设备状态分为了3类：<br/>1.在线：设备网络正常连接，并且无任何异常情况，可正常工作赚取收益；<br/>2.离线：设备网络未连接或掉线，无法赚取收益；<br/>3.异常：设备网络正常连接，但是存在异常情况，无法赚取收益或影响收益。',
      },
      {
        question: '目前设备会有哪些异常情况？',
        id: 'device-6',
        answer:
          '目前总共5种异常情况：<br/>1.硬盘异常：硬盘无法识别或存在损坏等情况；<br/>2.IP异常：设备所处IP省份运营商与购买激活码限制省份运营商不同，无法赚取收益；<br/>3.非网心云设备：当前设备为非网心云设备；<br/>4.升级中：玩客云固件版本过低，正在升级至最新版本；<br/>5.未绑定设备：添加的玩客云账号下面未绑定设备。',
      },
      {
        question: '为什么我的设备不支持弹出硬盘？',
        id: 'device-7',
        answer: '目前弹出硬盘功能仅支持部分设备（x86、裸盘不支持弹出）',
      },
      {
        question: '设备详情信息是多久进行更新？',
        id: 'device-8',
        answer: '硬件设备相关信息大多数都是1-10分钟不等进行更新，可查看右上角显示的具体更新时间',
      },
      {
        question: '历史收益指标信息是多久进行更新？',
        id: 'device-9',
        answer: '历史收益指标于次日9点更新',
      },
      //   {
      //     question: '支付宝添加次数限制？',
      //     answer: '一天最多可添加3次，超过则会提示明日再试',
      //   },
      //   {
      //     question: '一个支付宝账号可以绑定多个网心账号吗？',
      //     answer: '可以，多个网心账号可以使用相同的支付宝提现。',
      //   },
      //   {
      //     question: '如何修改支付宝账号？',
      //     answer: '手机登录网心云，在【我的】—【我的钱包】—【收款账号】—添加或删除提现信息。',
      //   },
      //   {
      //     question: '提现大概多久到账？',
      //     answer:
      //       '正常情况1分钟内到账，如遇特殊情况最多2小时到账（各个银行根据实际情况可能会稍有不同，详细请咨询银行客服）。',
      //   },
      //   {
      //     question: '提现账号输入错误怎么办？',
      //     answer: '支付宝如果输入的账号与姓名不匹配，则会提现失败。',
      //   },
      //   {
      //     question: '提现失败是什么原因？',
      //     answer:
      //       '支付宝提现失败原因较多，请检查：1.账号与姓名是否正确；2.输入的账号是否为支付宝登录账号，而非绑定的手机号码。如果无法查明具体失败原因，请联系我们的客服人员。',
      //   },
      //   {
      //     question: '收益何时能进行提现？',
      //     answer: '每周二（10:00-18:00）可提现至支付宝账户，如遇节假日顺延至下周。',
      //   },
      // {
      // 	"question": "提现金额是否有限制？",
      // 	"answer": "支付宝每周提现上限为5000元"
      // },
      //   {
      //     question: '每天提现次数限制是多少？',
      //     answer: '支付宝一天最多提现5次',
      //   },
    ],
  },
  {
    id: 7,
    title: '收益提现',
    type: 'income',
    qa: [
      {
        question: '同一网络环境下，相同的设备和硬盘，为何收益不同？',
        id: 'income-1',
        answer:
          '同一网络环境下，导致收益不同的因素有以下原因：<br/>1、在同一带宽下，网络出口之间可能出现带宽资源相互抢占的情况；<br/>2、系统缓存数据和访问数据存在随机性，同时因为智能调度策略都会影响收益不同。',
      },
      {
        question: '为什么设备刚上机会出现0收益或低收益情况？',
        id: 'income-2',
        answer:
          '设备上线后需要5-7天的缓存部署期，待缓存部署完毕后，贡献的流量逐步提升，收益就会相对稳定。',
      },
      {
        question: '收益与哪些因素有关？',
        id: 'income-3',
        answer:
          '收益与实际贡献的上行流量正相关，影响因素包含：上行带宽（运营商网络容易有波动，特别是晚高峰）、磁盘容量和性能、upnp是否打开、NAT类型、缓存大小（与下行网络、磁盘容量质量相关）等相关。具体可查看APP中【收益指标】，观察指标的评级数据，若指标评级差可针对性优化，若遇异常，可联系客服解决。',
      },
      {
        question: '收益何时更新以及如何查看？',
        id: 'income-4',
        answer:
          '次日9点更新前一天0点到24点的收益，在【我的】—【我的钱包】查看累计收益、已提现收益和账户余额。',
      },
      {
        question: '为什么无法提现？提现时间/金额/次数等限制？',
        id: 'income-5',
        answer:
          '每周二（10:00-18:00）可进行提现，每种提现方式每日最多5次，如遇节假日顺延至下周：<br/>1、个人提现：支付宝提现每月限额800元（免税），银行卡提现需要扣除7%提现手续费（用于第三方代缴税）；<br/>2、企业提现：每个自然月最后一次提现后的五日内需将与该月提现总额相同的发票快递到网心科技，我方将在收到发票后的一周内审核完成，发票验证合格后，可继续提现。',
      },
      {
        question: '提现大概多久到账？',
        id: 'income-6',
        answer:
          '个人认证用户提现2小时内到账，企业认证用户最晚48小时到账。（各个银行根据实际情况可能会稍有不同，详细请咨询银行客服）',
      },
      {
        question: '提现失败是什么原因？',
        id: 'income-7',
        answer:
          '银行卡请联系客服处理；支付宝提现失败原因较多，请检查：<br/>1.账号与姓名是否正确；<br/>2.输入的账号是否为支付宝登录账号，而非绑定的手机号码。<br/>如果无法查明具体失败原因，请联系我们的客服人员。',
      },
      {
        question: '有哪些情况发票会抵扣失败？',
        id: 'income-8',
        answer:
          '1、无法认证：专用发票所列密文或者明文不能辨认，无法产生认证结果；<br/>2、纳税人识别号认证不符：专用发票所列购买方纳税人识别号有误；<br/>3、专用发票代码/号码认证不符：专用发票所列密文解译后与明文的代码或者号码不一致。',
      },
      {
        question: '发票需要如何盖章？',
        id: 'income-9',
        answer:
          '需要加盖发票专用章，不需要加盖税务机关代开发票专用章，不可以盖财务专用章或公章。如果盖章不清晰，可以在旁边补盖一个清晰的章，或者将发票作废或红冲。',
      },
    ],
  },
  {
    id: 8,
    title: '网络带宽',
    type: 'network',
    qa: [
      {
        question: '设备未跑满上行带宽正常吗？',
        id: 'network-1',
        answer:
          '磁盘中的业务文件是系统随机部署的，跑量高低受到文件热度的影响，可能会出现偶尔跑低、偶尔跑高的情况。',
      },
      {
        question: '为什么有一段时间没有流量？',
        id: 'network-2',
        answer:
          '目前流量调度策略尚不够成熟，会存在小部分设备流量分配不合理的现象。主要是调度部署策略和调度分发策略都有困难要攻关，我们会持续不断优化调度策略，一定能够做到把流量均衡起来，做到更加公平、更正。举个例子：有100个观众在观看视频，在100台设备中，只有10台设备存储该缓存的视频，但受到地域、运营商、网络环境等问题，导致只能访问其中1台设备，那么流量就会全部跑到这1台设备上面，就会出现偶尔跑高、偶尔跑低的现象。',
      },
      {
        question: '网络的NAT类型是什么意思？',
        id: 'network-3',
        answer:
          '当在专用网内部的一些主机本来已经分配到了本地IP地址（即仅在本专用网内使用的专用地址），但现在又想和因特网上的主机通信（并不需要加密）时，可使用NAT方法，以下为跑量排名：<br/>1、公网；<br/>2、映射公网；<br/>3、全锥NAT；<br/>4、IP限制NAT；<br/>5、端口限制NAT；<br/>6、对称型NAT；<br/>按是否有利于跑量，排名依次为1>2>3>4>5>6，可联系运营商查询您网络的NAT类型，尝试修改为排名靠前的类型。',
      },
      {
        question: '同一个IP下是否可以接入多台设备？',
        id: 'network-4',
        answer:
          '同IP地址下挂多台设备，会出现带宽资源互抢的情况，有可能影响您的收益，建议合理分配带宽资源。',
      },
      {
        question: '设备连不上网络怎么办？',
        id: 'network-5',
        answer:
          '1、确保路由器开启了DHCP功能；<br/>2、确保连接硬件设备和路由器的网线正常；<br/>3、确保路由器所在网络能够正常上网； <br/>4、如以上皆为正常，而仍然连不上设备请联系客服，我们会第一时间为您解决。',
      },
      {
        question: '路由器与网心云统计的流量为何有差异？',
        id: 'network-6',
        answer:
          '您好，网心云的流量统计是根据实际的云计算业务流量情况而定的，和用户自己通过路由器或者其它上层网络设备所作的网卡流量统计存在一定差距，例如：<br/>1、无效流量：由于网络传输协议的不可靠性，存在部分因数据重传、广播发现等机制而产生的无法被业务使用的流量；<br/>2、其它流量：用户在使用其它网络应用的过程产生的和网心业务无关的流量，也不会被统计在内。<br/>因此，业务流量和网卡流量存在一定的差值，但具体的大小根据每个用户的网络环境情况有所差异，需要进一步测试才能确定。<br/>如果您对此还有疑问，可联系客服，以进行详细核实，感谢您的理解和支持！',
      },
      {
        question: '使用网心云设备会影响家庭网络吗？',
        id: 'network-7',
        answer:
          '一般家庭用网主要用到的是下行带宽，而网心云设备多数情况下使用的是上行带宽，可以结合个人用网需求进行调整。',
      },
      {
        question: '使用网心云设备对环境/网络/设备有要求吗？',
        id: 'network-8',
        answer:
          '网心云设备的使用没有门槛，但是由于奖励额度是根据用户实际贡献的流量质量进行结算的，会因为运营商、在线时长等因素而波动，所以我们推荐使用移动网络，15M以上的上行带宽，以及240GB以上SSD硬盘，并保持每日在线24小时。',
      },
      {
        question: '路由器的选择对收益有影响吗？',
        id: 'network-9',
        answer:
          '通过技术人员分析，软路由和部分路由器的系统可能会对数据包有限制、或者是pps能力不足，导致跑不起量的现象。若您存在跑量起不来的情况，建议您通过以下方法排查：<br/>1、在路由器上开启UPNP；<br/>2、与正常跑量的设备，互换网络尝试观察一段时间；<br/>3、若使用软路由，可以更换硬路由尝试；<br/>4、以上排查无效，可以检测路由器是否有特殊设置，比如限制udp数据包、数据转发能力（pps）等，一些路由器的每秒转发数据包能力很差，会导致跑不起量，可以更换路由器尝试。<br/>温馨提示：同一带宽下挂多台玩客云，会存在带宽资源互抢的情况，从而影响跑量，建议您合理分配带宽资源。',
      },
    ],
  },
  {
    id: 9,
    title: '硬盘',
    type: 'disk',
    qa: [
      {
        question: '网心云如何设置磁盘共享空间？',
        id: 'disk-1',
        answer: '网心云目前按照最大磁盘空间共享，不支持设置',
      },
      {
        question: '为什么设备会出现频繁掉盘及离线的状况？',
        id: 'disk-2',
        answer:
          '通过分析，读写性能差的硬盘，会导致数据读写时一直处于等待的队列中，当等待队列越来越长时，就会出现频繁掉盘及设备离线的现象，建议您使用读写能力较好的硬盘。',
      },
      {
        question: '格式化磁盘后收益会提高吗？',
        id: 'disk-3',
        answer:
          '格式化硬盘收益上涨属于小部分设备，大部分设备由于损失缓存文件，存在收益不稳定且波动大的现象。经技术人员分析，格式化硬盘后，小部分设备收益上涨原因如下：<br />一、业务文件随机部署的概率性问题<br />由于磁盘中的业务文件是系统随机部署的，跑量高低受到文件热度的影响，因此会出现偶尔跑低、偶尔跑高的情况。<br />二、磁盘读写性能差<br />由于磁盘读写性能差，在缓存逐渐增加以后，由于读写的频繁增加，IO利用率也逐步提高，相对应的会暴露出读写性能差的弊端，会过度消耗系统资源，从而导致跑量降低。而在格式化硬盘以后，会短暂的释放部分IO资源，因为调度快速响应IO优的设备，跑量会暂时性提高。随着缓存逐渐增加，依然会出现IO跑高的现象。格式化磁盘对磁盘本身也是一种损耗，建议结合个人情况，更换读写性能更好、品质优良的磁盘使用，网心将会继续优化调度策略。<br/>备注：格式化磁盘会删除磁盘中的数据，因此在格式化硬盘前，请确保硬盘中无个人数据。',
      },
      {
        question: '磁盘如果存在坏道，会影响收益吗？',
        id: 'disk-4',
        answer: '若需要调度的数据刚好在坏道上，会对收益产生影响，尽量避免使用坏盘。',
      },
      {
        question: '双盘会比单盘的收益高吗？',
        id: 'disk-5',
        answer:
          '可以使用双盘，2*240G SSD跑量效果优于480G SSD，但具体收益与实际跑量有关，双盘收益不一定高。另外机械盘会有一定的性能瓶颈，与固态盘混用时可能会影响收益，更推荐使用存储较大的固态单盘。',
      },
      {
        question: '1T的机械盘与240G的固态盘谁更有优势？',
        id: 'disk-6',
        answer:
          '前期因为缓存较少，固态硬盘IO性能更优，会更具优势。中后期因为机械盘容量更大，能够存储的缓存文件更多，访问命中更高，会更具优势。推荐您使用读写性能更好、质量优良的大容量的磁盘。',
      },
      {
        question: '如何选择合适的磁盘？',
        id: 'disk-7',
        answer:
          '关于磁盘购买，建议优选固态、京东3年质保的品牌硬盘，IOPS大家也可以找些开源的软件进行测试，一般要测试4个指标，顺序读、顺序写、随机读、随机写，很多盘的随机读写能力不够好，也是会有影响的。',
      },
      {
        question: '更换硬盘会影响收益吗？',
        id: 'disk-8',
        answer:
          '更换硬盘后，前期会重新部署缓存，不同机器、区域和网络环境部署缓存的速度会有一定的差异。因此，收益提升的速度也不同，建议您耐心观察一段时间。',
      },
      {
        question: '为什么硬盘无法识别？',
        id: 'disk-9',
        answer:
          '1、网心云外接2个硬盘<br />两个USB接口提供给外接硬盘的电流输出总和为3A，可以满足大多数的两个硬盘同时使用。如果同时使用两个硬盘无法识别，请先拔下其中一个硬盘查看是否可以识别，两个硬盘中的任意一个都可以识别，那可能就是由于输出电流过高造成的无法识别；<br />2、玩客云外接1个硬盘或其他异常<br />2.1请确认硬盘在电脑上可以使用；<br />2.2请确保硬盘电流输出要求小于3A与小融盒子连线正常；<br />2.3确保硬盘的文件系统是NTFS、EXT4或者MAC的HFS+中的一种；<br />2.4更换USB接口尝试，如果可以正常识别，说明原先的UBS接口可能存在硬件故障；<br />2.5更换其他硬盘尝试，如果其他硬盘可以识别，说明原硬盘可能存在异常需要修复，可百度HDTunePro、DiskGenius等开源软件尝试修复，必要时可以考虑格式化硬盘，格式化前请您先备份硬盘中的重要数据。若以上方法均无法解决，可联系客服反馈处理。',
      },
      {
        question: '缓存写入的方式有哪几种？',
        id: 'disk-10',
        answer:
          '缓存写入有两种方式（预占后写和直接写入），请耐心等待实际缓存上涨，收益会逐渐提高至平稳阶段。',
      },
      {
        question: '缓存系统会自动删除吗？',
        id: 'disk-11',
        answer: '缓存资源由系统调度分配，会根据资源的冷热门程度进行调整，无需手动删除缓存。',
      },
      {
        question: '磁盘无法写满正常吗？',
        id: 'disk-12',
        answer:
          '磁盘在写满后，会严重降速，尤其是SSD硬盘，从而跑不起来流量。系统会为您预留10%的磁盘空间，以免磁盘写满降速，部分性能较差的磁盘可能不支持该项技术。若磁盘长期处于写满状态，属于设备异常，可联系客服反馈处理。',
      },
      {
        question: '旧硬盘的缓存可以使用吗？',
        id: 'disk-13',
        answer: '可以在其他设备进行使用，但缓存不能拷贝，会造成文件索引异常。',
      },
      {
        question: '硬盘文件系统哪个收益更好？',
        id: 'disk-14',
        answer: '裸盘稳定性最好，收益也是最稳定，EXT4次之，NTFS最差。',
      },
    ],
  },
];
